import { allValidStateCodes } from '@cx-modules/constants';
import { type StateCode } from '@cx-modules/types';

export function getStateFromHeader(request: Request): StateCode | '' {
  const state = request.headers.get('OC-Selected-State');
  if (!state || !isValidState(state)) return '';
  return state as StateCode;
}

export function isValidState(state: string): state is StateCode {
  return allValidStateCodes.includes(state as StateCode);
}
